import { render, staticRenderFns } from "./ModalVisualizacao.vue?vue&type=template&id=8b987c8e"
import script from "./ModalVisualizacao.vue?vue&type=script&lang=ts"
export * from "./ModalVisualizacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports